module.exports = __webpack_public_path__ + "static/media/meter_3.604119dc.svg";